import React from "react";
import "./PopUpInfo.scss";

function PopUpInfo({ popUpOpen, setPopUpOpen }) {
  return (
    <>
      {popUpOpen ? (
        <section className="popup">
          <div className="popup__content">
            <p
              className="x"
              onClick={() => {
                setPopUpOpen(false);
              }}
            >
              X
            </p>
            <p className="popup__content__title">
              Affordability Score Definition
            </p>
            <p className="popup__content__copy">
              This number measures whether a typical family can afford the
              monthly mortgage payments on a typical home. A value of 100 means
              that a family with the median income has exactly enough to qualify
              for a mortgage. A score above 100 signifies that a median-income
              family has more than enough to qualify. A score below 100
              signifies that a typical family will struggle to qualify. In
              short, the higher the index value, the more affordable a region
              is.
            </p>
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
}

export default PopUpInfo;
